const audio = {
  namespaced: true,

  state: {
    tritoneAudio: new Audio('./static/tritone.mp3')
  },

  mutations: {

  },
  actions: {
    playTirtone: ({ state }) => {
      state.tritoneAudio.play()
    }
  }
}

export default audio



// WEBPACK FOOTER //
// ./src/store/modules/audio.js